module.exports = __webpack_public_path__ + "img/face82.c5f397cf.gif";